import { useSetRecoilState } from 'recoil'
import usePreference from './usePreference'
import { currentUserProcessPreferences } from 'store/atoms'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const useUserProcessPreferences = (processId) => {
	const location = useLocation()
	const tab = location.pathname.split('/').pop()
	const selectedTab = tab === processId || tab === '' ? 'root' : tab

	const defaultValue = JSON.stringify({
		unfolded: false,
		order: false,
	})
	const setCurrentUserProcessPreferences = useSetRecoilState(
		currentUserProcessPreferences
	)
	const [tabMenuPreference, setTabMenuPreference] = usePreference(
		'controllerPreferences',
		`{"appointments": ${defaultValue}, "requisitions": ${defaultValue}}`,
		JSON.parse
	)

	const getMenuPreference = () => {
		setCurrentUserProcessPreferences(tabMenuPreference[selectedTab])
		return tabMenuPreference[selectedTab]
	}

	const setMenuExpandPreference = (value) => {
		setTabMenuPreference((prev) => {
			const nextState = {
				...prev,
				[selectedTab]: {
					...prev[selectedTab],
					unfolded: value,
				},
			}
			return JSON.stringify(nextState)
		})
	}

	const setMenuSortPreference = (value) => {
		setTabMenuPreference((prev) => {
			const nextState = {
				...prev,
				[selectedTab]: {
					...prev[selectedTab],
					order: value,
				},
			}
			return JSON.stringify(nextState)
		})
	}

	return [getMenuPreference, setMenuExpandPreference, setMenuSortPreference]
}

export default useUserProcessPreferences
